<fn-modal-header class="modal-header">
    <h5 class="modal-title">Set data for query string</h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</fn-modal-header>
<mat-dialog-content class="ps-10 pe-10 pt-10">
    <div class="row m-0">
        <div class="col-12">
            <textarea placeholder="text area...... " alta-nice-scroll nice-option="{'horizrailenabled' : true}"
                [(ngModel)]="text" rows="8" type="text" class="form-control resize-none"></textarea>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="row">
        <div class="col-6">
            <fn-button [type]="'success'" btnClass="btn-sm btn-round width-100" [text]="'Parse String'"
                (click)="parse(text,true)"></fn-button>
        </div>
        <div class="col-6 text-right">
            <fn-button [type]="'success'" btnClass="btn-sm btn-round width-100" [text]="'Parse Non String'"
                (click)="parse(text,false)"></fn-button>
        </div>
    </div>
</mat-dialog-actions>
